var RwClassRiservata = (function () {

  // ---------------------------------------------------------------------------
  // VERIFICA LOGIN DA CLASSE BODY
  // usare solo per controlli funzioni
  // il php richiamato va comunque controllato da rwpc_allowed()
  var isLogged = function () {

    if($('body').hasClass('pc_logged')){
      return true;
    } else {
      return false;
    }

  };


  // ---------------------------------------------------------------------------
  // REGISTRAZIONE - PASSWORD STORAGE & ENCRYPT
  // elimino conferma password dal form di registrazione
  // registro la password in un local storage per recuperarla al login (login automatico)
  var pswStorage = function () {

    // TDL in prox versione potrei usare il campo email o username al posto di crearne uno Custom
    // così non serve user data add-on e funziona stand alone
    var token = JSON.stringify($.now());
    $('.form-registrazione .pc_f_registration-token input[name=registration-token]').val(token);

    // Acquisisco anche la pagina da cui l'utente si è registrato
    // così posso gestire il redirect dopo la registrazione
    $('.form-registrazione .pc_f_pagina-registrazione input[name=pagina-registrazione]').val(RwUtil.getUrl());

    // Ad ogni keyup codifico la password in locale
    $('.form-registrazione .pc_registration_form input[name="psw"]').keyup(function(){
      valore = $(this).val();
      // copio il valore inserito sul campo conferma password
      $('.form-registrazione .pc_registration_form input[name="check_psw"]').val(valore);
      // imposto un local storage con la psw per recuperarla al login
      // utilizzando il valore cryptato
      localStorage.setItem('rwgestsecret', encrypt(valore, token));
      // console.log(decrypt(localStorage.getItem('rwgestsecret'), token));
    });

    // USERNAME PRECOMPILATO DA MAIL
    $('.form-registrazione .pc_registration_form input[name="email"]').keyup(function(){
      valore = $(this).val().replace(/\@/g, '-').replace(/\./g, '');
      // copio il valore inserito sul username
      $('.form-registrazione .pc_registration_form input[name="username"]').val(valore);
    });

  };


  // ---------------------------------------------------------------------------
  // REGISTRAZIONE - AUTO LOGIN DEL GESTORE
  // dopo la verifica via email recupero usr psw e urlRedirect
  // vengono passati via ajax alla funzione php che esegue il login tramite api private content
  var autoLoginGestore = function () {
    // username
    var username = RwUtil.getUrlParam('usr');
    var userId = RwUtil.getUrlParam('pcma_user');
    // password
    token = RwUtil.getUrlParam('token');
    cryptedPsw = localStorage.getItem('rwgestsecret');
    var password = decrypt(cryptedPsw, token);
    // redirect - non lo specifico, sono già nella pagina
    // var urlRedirect = $('#gestore-attivato').data('redirect');
    // RwAjaxRiservata.AjaxLoginGestore(username, password, urlRedirect);
    RwAjaxRiservata.AjaxLoginGestore(username, password, userId);
  }


  // ---------------------------------------------------------------------------
  // REGISTRAZIONE - ENCRYPT STRING
  var encrypt = function(str, key) {
    //CryptoJS.AES.encrypt(str, "Secret Passphrase")
    return CryptoJS.AES.encrypt(str, key);
  }


  // ---------------------------------------------------------------------------
  // REGISTRAZIONE - STRING
  // https://codepen.io/gabrielizalo/pen/oLzaqx
  var decrypt = function(str, key) {
    return CryptoJS.AES.decrypt(str, key).toString(CryptoJS.enc.Utf8);
  }


  return {
    IsLogged : isLogged,
    RegistraGestore : pswStorage,
    AutoLoginGestore : autoLoginGestore,
    Decrypt : decrypt
  }


})();
